/* Editorial pages: carry ad params onto CTA links, sticky CTA bar, reading progress. */
(function () {
  if (window.ggEditorialInit) return;
  window.ggEditorialInit = true;

  var KEEP = /^(utm_[a-z_]+|fbclid|gclid|ttclid)$/;

  function passParams() {
    var pass = [];
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (KEEP.test(key)) pass.push([key, value]);
    });
    if (!pass.length) return;

    document.querySelectorAll('a[data-ed-cta]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        if (url.origin !== window.location.origin) return;
        pass.forEach(function (pair) {
          if (!url.searchParams.has(pair[0])) url.searchParams.set(pair[0], pair[1]);
        });
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {}
    });
  }

  function initScroll() {
    var sticky = document.querySelector('[data-ed-sticky]');
    var progress = document.querySelector('[data-ed-progress]');
    if (!sticky && !progress) return;

    var offset = sticky ? parseInt(sticky.getAttribute('data-offset'), 10) || 600 : 0;
    var inlineCtaVisible = 0;

    if (sticky && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inlineCtaVisible += entry.isIntersecting ? 1 : -1;
        });
        inlineCtaVisible = Math.max(0, inlineCtaVisible);
        update();
      });
      document.querySelectorAll('.ed [data-ed-cta]').forEach(function (el) {
        observer.observe(el);
      });
    }

    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      if (sticky) {
        sticky.classList.toggle('is-visible', y > offset && inlineCtaVisible === 0);
      }
      if (progress) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  function init() {
    passParams();
    initScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
